import { render, staticRenderFns } from "./CourseReportPage.vue?vue&type=template&id=777cf76a&"
import script from "./CourseReportPage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CourseReportPage.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports